import React, { useState } from 'react';
import { ChevronDownIcon, ChevronRightIcon } from 'lucide-react';
interface FilterSidebarProps {
  selectedFilters: {
    brands: string[];
    priceRange: {
      min: number;
      max: number;
    };
    categories: string[];
    needsPrescription: boolean;
    isExpress: boolean;
    isGlobal: boolean;
    offers: string[];
  };
  onFilterChange: (filters: any) => void;
}
export function FilterSidebar({
  selectedFilters,
  onFilterChange
}: FilterSidebarProps) {
  const [expandedSections, setExpandedSections] = useState({
    price: true,
    brands: true,
    categories: true,
    offers: true
  });
  const brands = ['Pampers', 'Huggies', 'Babyjoy', 'Fine Baby', 'Bambi', 'Molfix'];
  const categories = ['Baby Diapers', 'Training Pants', 'Swim Diapers', 'Overnight Diapers', 'Eco-Friendly Diapers'];
  const offers = ['On Sale', 'Special Offers', 'Buy One Get One', 'Clearance'];
  const toggleSection = (section: string) => {
    setExpandedSections({
      ...expandedSections,
      [section]: !expandedSections[section]
    });
  };
  const handleBrandToggle = (brand: string) => {
    const newBrands = selectedFilters.brands.includes(brand) ? selectedFilters.brands.filter(b => b !== brand) : [...selectedFilters.brands, brand];
    onFilterChange({
      ...selectedFilters,
      brands: newBrands
    });
  };
  const handleCategoryToggle = (category: string) => {
    const newCategories = selectedFilters.categories.includes(category) ? selectedFilters.categories.filter(c => c !== category) : [...selectedFilters.categories, category];
    onFilterChange({
      ...selectedFilters,
      categories: newCategories
    });
  };
  const handleOfferToggle = (offer: string) => {
    const newOffers = selectedFilters.offers.includes(offer) ? selectedFilters.offers.filter(o => o !== offer) : [...selectedFilters.offers, offer];
    onFilterChange({
      ...selectedFilters,
      offers: newOffers
    });
  };
  const handleReset = () => {
    onFilterChange({
      brands: [],
      priceRange: {
        min: 0,
        max: 5000
      },
      categories: [],
      needsPrescription: false,
      offers: []
    });
  };
  return <div className="bg-white rounded-xl border border-gray-200 shadow-sm" data-id="element-1637" data-mp="cgbi2ztkm6x1">
      {/* Price Filter */}
      <div className="border-b border-gray-100" data-id="element-1638" data-mp="hfemci1q893y">
        <button onClick={() => toggleSection('price')} className="flex justify-between items-center w-full p-5 text-left hover:bg-gray-50" data-id="element-1639" data-mp="2o5tm02j27ml">
          <h3 className="text-base font-bold text-gray-900" data-id="element-1640" data-mp="3pt3nnispkz5f">Filter By Price</h3>
          {expandedSections.price ? <ChevronDownIcon className="w-5 h-5 text-gray-500" data-id="element-1641" data-mp="3urf081ae1nrc" /> : <ChevronRightIcon className="w-5 h-5 text-gray-500" data-id="element-1642" data-mp="3fv7hz6ijiwep" />}
        </button>
        {expandedSections.price && <div className="px-5 pb-5" data-id="element-1643" data-mp="3ksz93ybd2ehu">
            <div className="flex justify-between mb-2 text-sm text-gray-700" data-id="element-1644" data-mp="3kw4vv6wip4ae">
              <span data-id="element-1645" data-mp="318qvcwkevoji">{selectedFilters.priceRange.min} SAR</span>
              <span data-id="element-1646" data-mp="2x75g54kemy65">— {selectedFilters.priceRange.max} SAR</span>
            </div>
            <div className="relative h-2 bg-gray-200 rounded-full" data-id="element-1647" data-mp="3b65224gj8yym">
              <div className="absolute h-full w-1/3 bg-[#0066CC] rounded-full" data-id="element-1648" data-mp="3b4brwf6pnwlv"></div>
            </div>
          </div>}
      </div>
      {/* Brand Filter */}
      <div className="border-b border-gray-100" data-id="element-1649" data-mp="3k61l9qk5l5ma">
        <button onClick={() => toggleSection('brands')} className="flex justify-between items-center w-full p-5 text-left hover:bg-gray-50" data-id="element-1650" data-mp="3k4qj1v6cw5xa">
          <h3 className="text-base font-bold text-gray-900" data-id="element-1651" data-mp="3tw4m2cxinnv6">Brands</h3>
          {expandedSections.brands ? <ChevronDownIcon className="w-5 h-5 text-gray-500" data-id="element-1652" data-mp="3ozwbzdy6ekuv" /> : <ChevronRightIcon className="w-5 h-5 text-gray-500" data-id="element-1653" data-mp="7q7n7i7ff2ty" />}
        </button>
        {expandedSections.brands && <div className="px-5 pb-5" data-id="element-1654" data-mp="2os6218ddggu">
            <input type="text" placeholder="Search brands" className="w-full p-2 mb-3 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#0066CC]" data-id="element-1655" data-mp="1wa3opbo85zd8" />
            <div className="space-y-2 max-h-48 overflow-y-auto" data-id="element-1656" data-mp="25zx0acodaehh">
              {brands.map(brand => <label key={brand} className="flex items-center cursor-pointer" data-id="element-1657" data-mp="2b0ayl3062a2b">
                  <input type="checkbox" checked={selectedFilters.brands.includes(brand)} onChange={() => handleBrandToggle(brand)} className="w-4 h-4 text-[#0066CC] border-gray-300 rounded focus:ring-[#0066CC]" data-id="element-1658" data-mp="1dc10gz3i46gh" />
                  <span className="ml-2 text-sm text-gray-700" data-id="element-1659" data-mp="1s5nmbkdtla2r">{brand}</span>
                </label>)}
            </div>
          </div>}
      </div>
      {/* Category Filter */}
      <div className="border-b border-gray-100" data-id="element-1660" data-mp="33p055hjzr7lg">
        <button onClick={() => toggleSection('categories')} className="flex justify-between items-center w-full p-5 text-left hover:bg-gray-50" data-id="element-1661" data-mp="rztlyrsr31ao">
          <h3 className="text-base font-bold text-gray-900" data-id="element-1662" data-mp="i9qtcspjjpcv">Categories</h3>
          {expandedSections.categories ? <ChevronDownIcon className="w-5 h-5 text-gray-500" data-id="element-1663" data-mp="db5scr2gt1nd" /> : <ChevronRightIcon className="w-5 h-5 text-gray-500" data-id="element-1664" data-mp="8bb4kwdzks6j" />}
        </button>
        {expandedSections.categories && <div className="px-5 pb-5" data-id="element-1665" data-mp="48woul5m68jh">
            <div className="space-y-2" data-id="element-1666" data-mp="4c28hkvh4i7t">
              {categories.map(category => <label key={category} className="flex items-center cursor-pointer" data-id="element-1667" data-mp="3vgiswew8wd0v">
                  <input type="checkbox" checked={selectedFilters.categories.includes(category)} onChange={() => handleCategoryToggle(category)} className="w-4 h-4 text-[#0066CC] border-gray-300 rounded focus:ring-[#0066CC]" data-id="element-1668" data-mp="1tonq6oryvius" />
                  <span className="ml-2 text-sm text-gray-700" data-id="element-1669" data-mp="3nxt3e7wy9csh">{category}</span>
                </label>)}
            </div>
          </div>}
      </div>
      {/* Prescription Toggle */}
      <div className="border-b border-gray-100 p-5" data-id="element-1670" data-mp="3e7q27kfocsj2">
        <label className="flex items-center justify-between cursor-pointer" data-id="element-1671" data-mp="5r4zumhjsxox">
          <span className="text-base font-bold text-gray-900" data-id="element-1672" data-mp="5p1zb8irrm5y">
            Needs Prescription
          </span>
          <div className="relative" data-id="element-1673" data-mp="anvf57lj3p9a">
            <input type="checkbox" checked={selectedFilters.needsPrescription} onChange={e => onFilterChange({
            ...selectedFilters,
            needsPrescription: e.target.checked
          })} className="sr-only peer" data-id="element-1674" data-mp="3rz4jnmtxolo0" />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-[#0066CC] rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-[#0066CC]" data-id="element-1675" data-mp="2lg6g9srp10dd"></div>
          </div>
        </label>
      </div>
      {/* Offers Filter */}
      <div className="border-b border-gray-100" data-id="element-1676" data-mp="kueioecounen">
        <button onClick={() => toggleSection('offers')} className="flex justify-between items-center w-full p-5 text-left hover:bg-gray-50" data-id="element-1677" data-mp="fvlexdn7earo">
          <h3 className="text-base font-bold text-gray-900" data-id="element-1678" data-mp="tob41qy13vt0">Offers</h3>
          {expandedSections.offers ? <ChevronDownIcon className="w-5 h-5 text-gray-500" data-id="element-1679" data-mp="165q4378gfem" /> : <ChevronRightIcon className="w-5 h-5 text-gray-500" data-id="element-1680" data-mp="142tv1fhlq1g" />}
        </button>
        {expandedSections.offers && <div className="px-5 pb-5" data-id="element-1681" data-mp="lzwbexi1r40f">
            <div className="space-y-2" data-id="element-1682" data-mp="m0xn946vzuj7">
              {offers.map(offer => <label key={offer} className="flex items-center cursor-pointer" data-id="element-1683" data-mp="qzhad7x7vcd5">
                  <input type="checkbox" checked={selectedFilters.offers.includes(offer)} onChange={() => handleOfferToggle(offer)} className="w-4 h-4 text-[#0066CC] border-gray-300 rounded focus:ring-[#0066CC]" data-id="element-1684" data-mp="uzjc1h2yc5sf" />
                  <span className="ml-2 text-sm text-gray-700" data-id="element-1685" data-mp="19wa578m18l9l">{offer}</span>
                </label>)}
            </div>
          </div>}
      </div>
      {/* Reset Button */}
      <div className="p-5" data-id="element-1686" data-mp="1ipvmaylo6em6">
        <button onClick={handleReset} className="w-full py-3 bg-gray-400 text-white rounded-lg font-medium hover:bg-gray-500 transition-colors" data-id="element-1687" data-mp="1ip3vs26xj72r">
          Reset Filter
        </button>
      </div>
    </div>;
}